//线上图片路径
 function imagePath(value) {

if(value=='' || value==null){
    return require("../image/sxmoren.jpg")
}else{
    return "http://120.46.140.235:8091" +  value;//"http://120.46.140.235:8091" + 
}


   
}


export default imagePath;




